import React from 'react';
import PropTypes from 'prop-types';
import Card from 'react-bootstrap/Card';
import Loading from '../common/Loading';
import Highcharts from 'highcharts/highstock';
import HC_exporting from 'highcharts/modules/exporting';
import HC_accessibility from 'highcharts/modules/accessibility';
import HighchartsReact from 'highcharts-react-official';

const ammMetricList = [
  ['xrp_locked','Total XRP Locked'],
  ['amm_count','AMM Count'],
];

const highchartsConfig = (data, keyName) => {
  return {
    // Chart settings
    chart: {
      scrollablePlotArea: { minWidth: 600 },
    },
    plotOptions: {
      series: {
        dataGrouping: {
          enabled: false
        }
      }
    },
    title: {
      text: keyName[1],
    },
    subtitle: {
      text: `(${keyName[0]})`,
    },
    rangeSelector: {
        selected: 4,
    },
    yAxis: {
      labels: {
        formatter: function() {
          if ( this.value >= 1000 * 1000 )
            return Highcharts.numberFormat( this.value/1000000, 1) + " M";
          if ( this.value >= 1000 )
            return Highcharts.numberFormat( this.value/1000, 1) + " K";
          else
            return Highcharts.numberFormat(this.value, 0);
        },
      },
    },

    // Responsive settings
    responsive: {
      rules: [{
        condition: {
          maxWidth: 500
        },
        chartOptions: {
          chart: {
            height: 300
          },
          subtitle: {
            text: null
          },
          navigator: {
            enabled: false
          }
        }
      }]
    },

    // Export options
    exporting: {
      buttons: {
        contextButton: {
          menuItems: ['viewFullscreen', 'printChart'],
        },
      },
    },

    // Chart data
    series: [
    {
      name: keyName[0],
      type: 'areaspline',
      color: Highcharts.getOptions().colors[0],
      data: data,

      fillColor: {
        linearGradient: {
          x1: 0,
          y1: 0,
          x2: 0,
          y2: 1
        },
        stops: [
          [0, Highcharts.getOptions().colors[0]],
          [1, new Highcharts.Color(Highcharts.getOptions().colors[0]).setOpacity(0).get('rgba')]
        ]
        }    
    }],
  }
};

class MetricAMM extends React.Component {
  constructor(props) {
    super(props);
    HC_exporting(Highcharts);
    HC_accessibility(Highcharts);
  }

  componentDidMount() {
  }

  getChartData(metric, name) {
    return metric.map((datapoint) => [new Date(datapoint.date).getTime(), (typeof datapoint.amm === 'object') ? datapoint.amm[name] : null]);
  }

  render() {
    const { metric } = this.props;

    if (metric && metric.length === 0) {
      return <Loading />
    }

    return (
      <div>
        <br/>
        {ammMetricList.map((k,v) => {
          return (
            <Card className="shadow-sm" key={k}>
              <Card.Body>
                <HighchartsReact
                  highcharts={Highcharts}
                  constructorType={'stockChart'}
                  options={highchartsConfig(this.getChartData(metric, k[0]), k)}
                />
              </Card.Body>
            </Card>
          );
        })}
      </div>
    );
  }
}

MetricAMM.propTypes = {
  metric: PropTypes.array.isRequired,
}

export default MetricAMM;